import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-text-label-new-arrival-count"
}
const _hoisted_2 = { class: "p-text-label-new-arrival-count__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.count)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("span", {
          class: "p-text-label-new-arrival-count__body",
          style: _normalizeStyle({ backgroundColor: _ctx.colorCode })
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.count), 1)
        ], 4)
      ]))
    : _createCommentVNode("", true)
}